import React from 'react';
import { string } from 'prop-types';
import { Button } from '@thd-olt-component-react/core-ui';
import { useDrawer } from '@thd-olt-component-react/drawer';
import { Footer } from '../shared/Footer';

import * as styles from '../shared/messages.module.scss';
import * as drawerStyles from '../shared/drawers.module.scss';

export const SignInDrawer = () => {
  const { closeDrawer } = useDrawer();
  const thisUrl = window.location.href;
  return (
    <div className={drawerStyles.container}>
      <div className={drawerStyles.content}>
        <div className={styles.content}>
          <h4 className={styles.title}>Please Sign in</h4>
          <p className={styles.messageText}>Please log back in to Add to Quote</p>
        </div>
      </div>
      <Footer>
        <Button
          role="button"
          tag="a"
          href={`/auth/view/signin?redirect=/&ref=${thisUrl}`}
        >
          Sign In
        </Button>
        <Button outline className={styles.button} onClick={closeDrawer}>Cancel</Button>
      </Footer>
    </div>
  );
};
